import { useOnPressButtons } from '../../hooks/useOnPressButtons'
import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import './Page3-dark-link.css'

import page3icon1 from '../../assets/page-3-icon-1.png'
import page3icon2 from '../../assets/page-3-icon-2.png'
import page3icon3 from '../../assets/page-3-icon-3.png'
import page3bg from '../../assets/page-dark-bg.png'

const Page3 = () => {
  const { handlePressButtonIndex } = useOnPressButtons()
  const { isSalesPart } = useSelectReportData()
  if (!isSalesPart) return null

  return (
    <div
      className={'bg-image-config'}
      style={{
        position: 'relative',
        backgroundImage: `url(${page3bg})`,
      }}
    >
      {/*<img src={page3bg}*/}
      {/*	 style={{width: '100%', height: '100%', objectFit: 'cover', zIndex: 1, position: 'absolute', top: 0}}/>*/}
      <div style={{ maxWidth: '100%', padding: '40px 15px 40px 15px', zIndex: 2 }}>
        <p className='title-bold-2 inverted-text'>
          You've taken the first step towards a <span className='rainbow-text'>healthier you!</span>
        </p>
        <p className='text-on-dark'>
          Your 21 day assessment results have provided valuable insights into your metabolic health and helped us create a personalized plan that is tailored to your specific goals. Sign up for our
          Continued Care Program today and see the results you've been working towards become a reality!
        </p>
        <p
          className='title-bold-2 inverted-text'
          style={{ fontSize: '0.9rem' }}
        >
          What's included?
        </p>
        <p
          className='text-on-dark'
          style={{ marginTop: 5 }}
        >
          By embarking on our 12 or 24 week programs you will receive:
        </p>
        <div className='row-page-3'>
          <img
            src={page3icon1}
            className='icon-page-3'
          />
          <p
            className='text-on-dark'
            style={{ marginTop: 0, marginBottom: 0 }}
          >
            Continued coaching and tracking of your progress, so you can see the headway you're making towards your goals
          </p>
        </div>
        <div className='row-page-3'>
          <img
            src={page3icon2}
            className='icon-page-3'
          />
          <p
            className='text-on-dark'
            style={{ marginTop: 0, marginBottom: 0 }}
          >
            Access to state-of-the-art bio-sensing technology, such as continuous glucose monitoring and smart watch activity, heart rate & stress monitoring
          </p>
        </div>
        <div className='row-page-3'>
          <img
            src={page3icon3}
            className='icon-page-3'
          />
          <p
            className='text-on-dark'
            style={{ marginTop: 0, marginBottom: 0 }}
          >
            Clinical tests like blood, urine, genetic, and other testing to gather data about your metabolism to continually tune your plan, giving you the best possible chance of hitting your goals.
          </p>
        </div>
        <button
          onClick={handlePressButtonIndex(1)}
          className='button-rainbow'
          style={{ marginTop: 22 }}
        >
          Sign up now!
        </button>
      </div>
    </div>
  )
}

export default Page3
